import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Select from 'react-select';
import Toggle from 'react-toggle';

import { Link, Redirect} from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class UsersAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      staff_list: [],
      name: '',
      staff_id: '',
      email: '',
      id: '',
      exam: 0,
      client: 0,
      exam_instructor: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 
    
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/alunos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staff_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      client: this.state.client,
      exam: this.state.exam,
      exam_instructor: this.state.exam_instructor,
      email: this.state.email,
      name: this.state.name,
      staff_id: this.state.staff_id,
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/usuario', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/usuario/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastrar usuário</h3>
      <Link to="/usuarios" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Nome:</label>
            <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
          <div className="col-md-6 form-group">
            <label>E-mail:</label>
            <input type="text" className="form-control" name="email" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Funcionário:</label>
            <Select
              className=""
              name="staff_id"
              value={this.state.staff_id}
              searchable={true}
              placeholder={'Selecionar base'}
              onChange={this.handleSelectChange.bind(this, 'staff_id')}
              options={this.state.staff_list}
            />
          </div>
          <div className="col-md-6 form-group">
              <label>Usado em sigtrein?:</label>
              <br/>
              <Toggle
                checked={this.state.client}
                aria-label='No label tag'
                name="client"
                onChange={this.handleToggleChange.bind(this, 'client')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
              <label>Usado em provas?:</label>
              <br/>
              <Toggle
                checked={this.state.provas}
                aria-label='No label tag'
                name="exam"
                onChange={this.handleToggleChange.bind(this, 'exam')} />
          </div>
          <div className="col-md-6 form-group">
              <label>Usado em examinador de provas?:</label>
              <br/>
              <Toggle
                checked={this.state.exam_instructor}
                aria-label='No label tag'
                name="exam_instructor"
                onChange={this.handleToggleChange.bind(this, 'exam_instructor')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar</button>
          </div>
        </div>
      </form>  
    </div>
  </div>
</div>
    );
  }
}

export default UsersAdd;



// WEBPACK FOOTER //
// ./src/Components/Users/UsersAdd.js